// extracted by mini-css-extract-plugin
export default {"modal":"Views_modal__vlB5f","close":"Views_close__wfQ9S"};